import { Skeleton, Stack } from '@mui/material';

import clsx from 'clsx';

import ButtonSkeleton from '../../../../../../../components/Button/skeleton';
import RichTextEditorSkeleton from '../../../../../../../components/RichText/Editor/skeleton';
import { Actions, questionOptionClasses, RichTextEditorWrapper } from './styles';

export interface QuestionOptionSkeletonProps {
  className?: string;
}

const QuestionOptionSkeleton = ({ className }: QuestionOptionSkeletonProps) => {
  return (
    <Stack direction="row" borderRadius={2} overflow="hidden" className={className}>
      <Stack justifyContent="center" alignItems="center" p={1.25}>
        <Skeleton variant="text" width={12} height="100%" />
      </Stack>
      <RichTextEditorWrapper flex={1}>
        <RichTextEditorSkeleton
          toolbar={{ canFormatText: true, canInsertFormula: true, canUploadImage: false }}
          className={questionOptionClasses.richTextEditor}
          classes={{
            body: clsx(questionOptionClasses.richTextEditorBody, questionOptionClasses.richTextEditorBodySkeleton),
            errorMessage: questionOptionClasses.richTextEditorErrorMessage,
            toolbar: questionOptionClasses.richTextEditorToolbar,
          }}
        />
        <Actions>
          <ButtonSkeleton size="small" />
          <ButtonSkeleton size="small" />
          <ButtonSkeleton size="small" />
        </Actions>
      </RichTextEditorWrapper>
    </Stack>
  );
};

export default QuestionOptionSkeleton;
